import { render } from "./ScrollableView.vue?vue&type=template&id=339b1726"
import script from "./ScrollableView.vue?vue&type=script&lang=js"
export * from "./ScrollableView.vue?vue&type=script&lang=js"
script.render = render

export default script